import React from "react";

export const STATUS_STYLES = {
  draft: "bg-zinc-100 text-zinc-600 border-zinc-200",
  intake_running: "bg-blue-50 text-blue-700 border-blue-200",
  awaiting_confirmation: "bg-amber-50 text-amber-800 border-amber-200",
  declined: "bg-zinc-100 text-zinc-500 border-zinc-300",
  running: "bg-blue-50 text-blue-700 border-blue-200",
  submitting: "bg-blue-50 text-blue-700 border-blue-200",
  awaiting_approval: "bg-amber-50 text-amber-800 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  submitted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  failed: "bg-red-50 text-red-700 border-red-200",
  passed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-zinc-100 text-zinc-500 border-zinc-200",
  gated: "bg-amber-50 text-amber-800 border-amber-200",
  low_confidence: "bg-amber-50 text-amber-800 border-amber-200",
  mapped: "bg-emerald-50 text-emerald-700 border-emerald-200",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  unmapped: "bg-red-50 text-red-700 border-red-200",
};

const LABELS = {
  awaiting_approval: "Awaiting Approval",
  awaiting_confirmation: "Awaiting Confirmation",
  intake_running: "Pulling from HigherGov",
  low_confidence: "Low Confidence",
};

export function StatusBadge({ status, className = "", testid }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.draft;
  const label = LABELS[status] || status?.replace(/_/g, " ");
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium capitalize tracking-wide border rounded-sm ${style} ${className}`}
    >
      {label}
    </span>
  );
}
